import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

import edilenaImg from "../../../../assets/testimonials/edilenaImg.jpeg";
import barbaraImg from "../../../../assets/testimonials/barbaraImg.jpeg";
import camilaImg from "../../../../assets/testimonials/camila.jpeg";
import jeronimoImg from "../../../../assets/testimonials/jeronimoImg.jpg";
import axelImg from "../../../../assets/testimonials/axelImg.jpg";
import andreaImg from "../../../../assets/testimonials/andreaImg.jpg";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Edilena De Paris",
      role: "Secretária Executiva",
      content: "Eu travava MUITO ao falar inglês. Depois de 2 semanas com o Ataric, já consegui fazer uma apresentação em inglês sem tremer. Incrível!",
      rating: 5,
      image: edilenaImg,
    },
    {
      name: "Bárbara Dessbesell",
      role: "Veterinária",
      content: "Finalmente um app que me faz FALAR. Nada de ficar só lendo ou ouvindo. A IA realmente conversa comigo e me corrige na hora.",
      rating: 5,
      image: barbaraImg,
    },
    {
      name: "Camila Guaripuna",
      role: "Advogada",
      content: "Precisava melhorar meu inglês para reuniões internacionais. O Ataric me deu a confiança que eu precisava. Recomendo demais!",
      rating: 5,
      image: camilaImg,
    },
    {
      name: "Manoel Jerônimo",
      role: "Mecânico de Aeronaves",
      content: "Uso o Ataric 10 minutos por dia no caminho do trabalho. Simples, prático e funciona. Meu inglês nunca evoluiu tão rápido.",
      rating: 5,
      image: jeronimoImg,
    },
    {
      name: "Áxel Kovacki",
      role: "Programador",
      content: "A melhor coisa é não ter vergonha de errar. A IA não julga e ainda me ajuda a melhorar. Perfeito pra quem é tímido como eu!",
      rating: 5,
      image: axelImg,
    },
    {
      name: "Andrea Santana",
      role: "Piloto de Aeronaves",
      content: "Eu estou impressionada com o Ataric. É como ter um professor a mão, a qualquer horário, para praticar inglês. Para quem tem bloqueio para falar é o ideal. Ele corrige, sugere palavras e ao final da conversa ainda faz uma avaliação. Eu estou empolgada porque sei que será uma ferramenta maravilhosa para melhorar meu inglês!",
      rating: 5,
      image: andreaImg,
    },
  ];

  return (
    <section id="depoimentos" className="py-20 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 hero-gradient" />
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Pessoas reais,{" "}
            <span className="text-gradient">resultados reais.</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Histórias reais de quem está finalmente falando inglês...
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="card-glass rounded-2xl p-6 relative"
            >
              <Quote className="absolute top-4 right-4 w-8 h-8 text-primary/20" />
              
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                ))}
              </div>
              
              <p className="text-foreground mb-6 leading-relaxed">
                "{testimonial.content}"
              </p>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-primary/30 flex-shrink-0">
                  <img 
                    src={testimonial.image} 
                    alt={`Foto de ${testimonial.name}`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="font-medium text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
